<template>
  <v-layout align-start v-resize="getDimensions">
    <v-flex>
      <v-card>
        <v-card-text>
          <v-row dense>
            <v-col cols="6" sm="4" md="4" class="py-0 my-0">
              <v-dialog
                ref="dialogFecha"
                v-model="modalFechaInicial"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    type="date"
                    readonly
                    dense
                    ref="fechaInicial"
                    v-model="fechaInicial"
                    :rules="[$rules.requerido]"
                    @click="modalFecha = true"
                    :error-messages="errorMessages"
                    :label="'Fecha Inicial'"
                    v-bind="attrs"
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaInicial" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="cancelFechaInicial">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="setFechaInicial(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="6" sm="4" md="4" class="py-0 my-0">

            

              <v-dialog
                ref="dialogFecha"
                v-model="modalFechaFinal"
                :return-value.sync="date"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    outlined
                    type="date"
                    readonly
                    dense
                    ref="fechaFinal"
                    v-model="fechaFinal"
                    :rules="[$rules.requerido]"
                    @click="modalFechaFinal = true"
                    :error-messages="errorMessages"
                    :label="'Fecha Final'"
                    v-bind="attrs"
                    v-on="on"
                    required
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fechaFinal" scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text color="primary" @click="cancelFechaFinal">
                    Cancel
                  </v-btn>
                  <v-btn text color="primary" @click="setFechaFinal(date)">
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
            <v-col cols="12" sm="4" md="4" class="py-0 my-0">

              <v-autocomplete
                dense
                outlined
                ref="cliente"
                v-model="cliente"
                :items="itemsCliente"
                item-text="descripcion"
                item-value="id"
                @change="listar()"
                label="Cliente"
                required
              >

              <template v-slot:append-outer>
                <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    large
                    @click="exportarExcel"
                    color="primary"
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon dark> fa-solid fa-file-excel </v-icon>
                  </v-btn>
                </template>
                <span>Exportar a Excel</span>
              </v-tooltip>
            </template>
              </v-autocomplete>

              <v-spacer></v-spacer>

              
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>

      <v-card class="overflow-hidden">
        <v-sheet class="overflow-y-auto" :max-height="windowHeigth - (isMobile ? 330 : 200)">
          <v-data-table
            dense
            fixed-header
            :height="windowHeigth - (isMobile ? 330 : 200)"
            :headers="headers"
            :items="dtMedioPago"
            :hide-default-header="false"
            :hide-default-footer="true"
            mobile-breakpoint="0"
            sort-by="codigo"
            :search="searchAll"
            class="elevation-1"
            :loading="dtMedioPagoLoad"
            loading-text="Cargando... Espere por favor"
            :footer-props="{
              showFirstLastPage: true,
              'items-per-page-options': [-1, 100, 150, 200],
            }"
          >
            <template v-slot:[`item.importe`]="{ item }">
              <span class="font-weight-bold"
                >{{ $formatoNumero(item.importe) }}
              </span>
            </template>
            <template v-slot:[`item.saldo`]="{ item }">
              <span class="font-weight-bold"
                >{{ $formatoNumero(item.saldo) }}
              </span>
            </template>

            <template v-slot:[`item.fecha`]="{ item }">
              <span>{{ $formatoFechaSpanish(item.fecha) }} </span>
            </template>

            <template v-slot:no-data>
              <div>No se encontraron registros</div>
            </template>
          </v-data-table>
        </v-sheet>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";
import dialogMixin from "../plugins/dialogs.js";

export default {
  mixins: [dialogMixin],
  data() {
    return {
      //Declaración de variables globales
      user: this.$store.state.usuario.user,
      //Declaración de arrays
      dtMedioPago: [],
      dtMedioPagoLoad: false,

      color: "",

      fechaInicial: "",
      fechaFinal: "",
      errorMessages: "",
      //Declaración de variables de tabla

      headers: [
        {
          text: "Cabecera",
          value: "id_cabe",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Fecha",
          value: "fecha",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Factura",
          value: "factura",
          align: "left",
          class: "primary font-weight-black white--text text-subtitle-2",
        },

        {
          text: "Importe",
          value: "importe",
          align: "right",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
        {
          text: "Saldo",
          value: "saldo",
          align: "right",
          width: "130px",
          class: "primary font-weight-black white--text text-subtitle-2",
        },
      ],

      cliente: "",
      itemsCliente: [],

      searchAll: "",

      //variables de errrores
      valida: 0,
      errorMessages: "",
      modalFechaInicial: false,
      modalFechaFinal: false,
      date: new Date(Date.now() - new Date().getTimezoneOffset() * 60000)
        .toISOString()
        .substr(0, 10),
      error: "",
      //variables de tamaño de pantalla
      isMobile: false,

      width: document.documentElement.clientWidth,
      height: document.documentElement.clientHeight,

      windowWidth: window.innerWidth + this.auxWidth,
      windowHeigth: window.innerHeight,
    };
  },

  mounted() {
    this.getDimensions();
  },

  created() {
    this.$store.dispatch("actualizarTitulo", "Kardex de Bonos");
    //establecemos la fecha inicial como el primer día del mes actual
    this.fechaInicial = this.$formatoFecha(
      new Date(new Date().getFullYear(), new Date().getMonth(), 1)
    );
    this.fechaFinal = this.$formatoFecha(new Date());
    this.selectCliente();
  },
  beforeDestroy() {
    this.$store.dispatch("actualizarTitulo", "");
  },

  methods: {
    cancelFechaInicial() {
      let me = this;
      me.modalFechaInicial = false;
    },
    cancelFechaFinal() {
      let me = this;
      me.modalFechaFinal = false;
    },
    setFechaInicial() {
      let me = this;
      me.listar();
      me.modalFechaInicial = false;
    },
    setFechaFinal() {
      let me = this;
      me.listar();
      me.modalFechaFinal = false;
    },

    getDimensions() {
      this.width = window.innerWidth;
      this.height = window.innerHeight;
      this.isMobile = this.width < 768;
    },
    listar() {
      let me = this;
      me.dtMedioPagoLoad = true;
      if (me.cliente == "") {
        me.$store.dispatch("setSnackbar", {
          text: "Debe seleccionar un cliente",
          color: "error",
        });
        me.dtMedioPagoLoad = false;
        return;
      }

      axios
        .get(
          "api/reportes/ListarKardexBonos/" +
            me.cliente +
            "/" +
            me.fechaInicial +
            "/" +
            me.fechaFinal
        )
        .then(function (response) {
          me.dtMedioPago = response.data;
          me.windowWidth = window.innerWidth + me.auxWidth;
          me.windowHeigth = window.innerHeight;
          me.dtMedioPagoLoad = false;
        })
        .catch(function (error) {
          me.dtMedioPagoLoad = false;
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },
    selectCliente() {
      let me = this;

      axios
        .get("api/clientes/select/")
        .then(function (response) {
          me.itemsCliente = response.data;
        })
        .catch(function (error) {
          me.$store.dispatch("setSnackbar", {
            text:
              error == "Error: Network Error"
                ? "No se pudo conectar con el servidor"
                : error,
            color: "error",
          });
        });
    },

    exportarExcel() {
      let me = this;
      me.loadingExcel = true;
      axios({
        url:
          "api/reportes/GenerarExcelKardexBonos/" +
          me.cliente +
          "/" +
          me.fechaInicial +
          "/" +
          me.fechaFinal,
        method: "GET",
        responseType: "blob",
      }).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          "Reporte Kardex Bonos - " +
            this.$formatoFechaHoras(new Date()) +
            ".xlsx"
        );
        document.body.appendChild(link);
        link.click();
        me.loadingExcel = false;
        me.$store.dispatch("setSnackbar", {
          text: "Excel generado exitosamente",
          color: "success",
        });
      });
    },
  },
};
</script>
